// Brand assets rebuilt as crisp inline SVG (no raster logos supplied).
// Signature motif: map pin + tick. Teal #2BBFB3, Charcoal #2B2B2B, Gold #F5A623.

const PIN_PATH =
  "M50 4C29 4 12 21 12 42c0 26 38 54 38 54s38-28 38-54C88 21 71 4 50 4z";

// Pin with a tick inside. `bg` fills the pin body, `tick` colours the check.
export function PinMark({ size = 40, bg = "#2B2B2B", tick = "#2BBFB3", className = "" }) {
  return (
    <svg viewBox="0 0 100 108" width={size} height={(size * 108) / 100} className={className} aria-hidden="true">
      <path d={PIN_PATH} fill={bg} />
      <path
        d="M35 44 l11 11 l20 -22"
        fill="none"
        stroke={tick}
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// App icon: rounded teal square, dark pin, white tick.
export function AppIcon({ size = 56, className = "" }) {
  const r = size * 0.24;
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className={className} aria-hidden="true">
      <rect x="0" y="0" width="100" height="100" rx={r} fill="#2BBFB3" />
      <g transform="translate(24 16) scale(0.52)">
        <path d={PIN_PATH} fill="#2B2B2B" />
        <path
          d="M35 44 l11 11 l20 -22"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="9"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

// Horizontal wordmark: dark "Drive", teal "Assure".
export function Wordmark({ className = "", light = false, withIcon = true }) {
  const drive = light ? "#FFFFFF" : "#2B2B2B";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      {withIcon && <AppIcon size={30} />}
      <span className="font-display font-extrabold tracking-tight text-[1.35rem] leading-none">
        <span style={{ color: drive }}>Drive</span>
        <span style={{ color: "#2BBFB3" }}>Assure</span>
      </span>
    </span>
  );
}

// Pro wordmark with shield seal.
export function ProWordmark({ className = "", light = false }) {
  const drive = light ? "#FFFFFF" : "#2B2B2B";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <ProShield size={30} />
      <span className="font-display font-extrabold tracking-tight text-[1.35rem] leading-none">
        <span style={{ color: drive }}>Drive</span>
        <span style={{ color: "#2BBFB3" }}>Assure</span>
        <span
          className="ml-1.5 align-middle text-[0.6rem] font-bold px-1.5 py-0.5 rounded"
          style={{ background: "#F5A623", color: "#2B2B2B" }}
        >
          PRO
        </span>
      </span>
    </span>
  );
}

// Gold shield seal with pin + tick.
export function ProShield({ size = 44, className = "" }) {
  return (
    <svg viewBox="0 0 100 112" width={size} height={(size * 112) / 100} className={className} aria-hidden="true">
      <path
        d="M50 4 L90 20 V54 C90 82 72 100 50 108 C28 100 10 82 10 54 V20 Z"
        fill="#2B2B2B"
        stroke="#F5A623"
        strokeWidth="4"
      />
      <g transform="translate(29 22) scale(0.42)">
        <path d={PIN_PATH} fill="#F5A623" />
        <path
          d="M35 44 l11 11 l20 -22"
          fill="none"
          stroke="#2B2B2B"
          strokeWidth="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
